import { HttpMethod } from "../http-request";
import { ApiEndpointSpecification } from "./types";
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { GET_IO_CONFIG_DETAILS } from "./url-constants";

type GetIOConfigDetailsEndpointSpecifications = ApiEndpointSpecification;
export const GetIOConfigDetailsEndpointSpecification: GetIOConfigDetailsEndpointSpecifications = {
    url: GET_IO_CONFIG_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'GetIoConfigDetailRequestParams',
    requestBodySchemaName: 'GetIoConfigDetailRequestBody',
    okResponseSchemaName: 'GetIoConfigDetailOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
}

export const invokeIOConfigDetails = Helpers.makeApiRequestFn<
    Types.GetIOConfigDetailsRequestParams,
    Types.GetIOConfigDetailsRequestBody,
    Types.GetIOConfigDetailsOkResponse>(GetIOConfigDetailsEndpointSpecification)
